const accordionMenu = document.querySelectorAll(".js-menu");

function accordionToggle() {
  const content = this.nextElementSibling;
  this.classList.toggle("is-active");
  content.classList.toggle("is-open");
}

for (let i = 0; i < accordionMenu.length; i++) {
  accordionMenu[i].addEventListener("click", accordionToggle);
}

// utils
const getUrlQuery = () => {
  const queryStr = window.location.search.slice(1);  // 文頭?を除外
  const queries = {};

  // クエリがない場合は空のオブジェクトを返す
  if (!queryStr) return queries;

  // クエリ文字列を & で分割してqueriesに格納
  queryStr.split('&').forEach((queryStr) => {
    const queryArr = queryStr.split('=');
    queries[queryArr[0]] = queryArr[1];
  });

  return queries;
}

function getParam(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}
